import { EnvVariables } from './types';

export const LocalEnvVariables: EnvVariables = {
  backendUri: 'http://localhost:3000/api/',
  auth: {
    clientId: 'a2d6ea18-4756-43fc-a816-dff008b344d3',
    authFlow: {
      flowName: 'B2C_1A_PASSWORDLESSSIGNUPORSIGNIN',
      authority:
        'https://ipracticeacceptance.b2clogin.com/ipracticeacceptance.onmicrosoft.com/B2C_1A_PASSWORDLESSSIGNUPORSIGNIN',
    },
    knownAuthority: 'ipracticeacceptance.b2clogin.com',
    backendAuthScope: 'https://ipracticeacceptance.onmicrosoft.com/backendapi/user_access',
  },
  streamKey: 'ygc447p7t489',
  applicationInsightsConnectionString: '',
};
